module.exports = __webpack_public_path__ + "static/media/icon-history-white.d5097c71.svg";